import cookies from "../cookies"
import _ from "lodash"
import openSocket from 'socket.io-client'
import printJS from 'print-js'

const REDUCER_NOTIFICATION = "NOTIFICATION"

//var API = 'http://192.168.8.100:1605/v1/';
var API = 'http://localhost:1605/v1/';
if (process.env.NODE_ENV === 'production') {
    API = "/v1/"
}

export const socket = openSocket(API+"socket");

export var select = (data, type) => {
    return data[type]
}

export const apiUrlOpen = (url, params, print) => {
    return dispatch => {
        var apiKey = cookies.get("auth")
        var ext = "?token="+apiKey
        if(params !== undefined) {
            var _params = params
            if(typeof params === 'object') {
                _params = ""
                Object.keys(params).forEach((key) => {
                    _params = _params + "&" + key + "=" + params[key]
                })
            }
            ext += _params
        }
        var uri = API+url+ext
        if(print !== undefined && print !== false) { 
            setTimeout(function() {
                printJS({
                    printable:      uri,
                    modalMessage:   'Dokument wird geladen ...',
                    type:           'pdf',
                    showModal:      true,
                })
            }, 1000);
        } else {
            var win = window.open(uri, '_blank');
            win.focus();
        }
        dispatch({
            type: "API_URL_OPEN",
            url: API+url+ext
        })
    }
}

export const doMessage = (type, message) => {
    return dispatch => {
        dispatch({
            type: REDUCER_NOTIFICATION,
            messageType: type,
            message: message
        })
    }
}

export const goBack = (type, key) =>{
    type = type.toUpperCase()
    return dispatch => {
        dispatch({
            type: type + "_REVERSE",
            goToKey: key,
        })
    }
}

export const doDialogOpen = (type, open) => {
    type = type.toUpperCase()
    return dispatch => {
        dispatch({
            type: type + "_DIALOG",
            dialogOpen: open
        })
    }
}

export const doPost = (type, url, postData, doAdd, doSingle, addAsc) => {
    type = type.toUpperCase()
    return dispatch => {

        dispatch({
            type: type + "_LOADING",
            isLoading: true,
        })

        var apiKey = cookies.get("auth")

        var headerData = {
            method: "POST",
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + apiKey
            },
            body: JSON.stringify(postData),
        }

        fetch(API + url, headerData)
            .then(response => response.json())
            .then(data => {
                if(data.message !== undefined && data.status != 200) {
                    throw new Error(data.message)
                }

                dispatch({
                    type: type+"_ADD",
                    newData: data,
                    isLoading: false,
                    dialogOpen: false,
                    doAdd: doAdd,
                    addAsc: addAsc,
                    doSingle: doSingle
                })

                dispatch({
                    type: REDUCER_NOTIFICATION,
                    messageType: "success",
                    message: "Eintrag wurde erstellt!"
                })

                if(data.Reload) {
                    dispatch({
                        type: type+"_RELOAD",
                        isLoading: false,
                        dialogOpen: false
                    })
                }
            }).catch(function(error) {
                /*dispatch({
                    type: type+"_ERROR",
                    message: error.message
                })*/
                dispatch({
                    type: REDUCER_NOTIFICATION,
                    messageType: "error",
                    message: error.message
                })
            });

    }
}

export const doReset = (type) => {
    type = type.toUpperCase()
    return dispatch => {
        dispatch({
            type: type + "_RESET",
        })
    }
}

export const doLoad = (type, url, postData) => {
    type = type.toUpperCase()
    return dispatch => {

        dispatch({
            type: type + "_LOADING",
            isLoading: true,
        })

        var apiKey = cookies.get("auth")

        var headerData = {
            method: "GET",
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + apiKey
            }
        }

        var extUrl = ""
        var extUrlData = []
        if(postData!==null && postData!==undefined) {
            Object.keys(postData).forEach((key) => {
                extUrlData.push(key+"="+postData[key])
            });
            if(extUrlData.length > 0) {
                extUrl = "?" + extUrlData.join("&")
            }
        }

        fetch(API + url + extUrl, headerData)
            .then(response => response.json())
            .then(data => {

                if(data.status !== 200) {
                    throw new Error("Fehler beim laden")
                }

                dispatch({
                    type: type,
                    ...data
                })

        }).catch(function(error) {
            dispatch({
                type: type+"_ERROR",
                message: error.message
            })
        });

    }

}

export const doPut = (type, url, putData, doAdd) => {
    type = type.toUpperCase()
    return dispatch => {
        //console.log(type, url, putData)

        dispatch({
            type: type + "_PUT",
            isLoading: true,
            id: putData.id
        })

        var apiKey = cookies.get("auth")

        if(_.has(putData, 'created_at')) {
            delete putData["created_at"]
        }

        if(_.has(putData, 'updated_at')) {
            delete putData["updated_at"]
        }

        var headerData = {
            method: "PUT",
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + apiKey
            },
            body: JSON.stringify(putData),
        }

        fetch(API + url, headerData)
            .then(response => {
                if(doAdd === undefined) {
                    dispatch({
                        type: type+"_PUT",
                        isLoading: false,
                        id: putData.id,
                        putData: putData
                    })
                }
                if(response.status === 204) {
                    return {}
                } else {
                    return response.json()
                }
                
            }).then(data => {
                if(data.message !== undefined) {
                    throw new Error(data.message)
                }

                console.log("data", data)

                if(doAdd === undefined) {
                    dispatch({
                        type: type+"_PUT",
                        isLoading: false,
                        id: putData.id,
                        putData: data
                    })
                }

                if(data.Reload) {
                    dispatch({
                        type: type+"_RELOAD",
                        isLoading: false,
                        dialogOpen: false
                    })
                }
                /*dispatch({
                    type: REDUCER_NOTIFICATION,
                    messageType: "success",
                    message: "Eintrag wurde gespeichert"
                })*/
        }).catch(function(error) {
            dispatch({
                type: type+"_ERROR",
                message: error.message
            })
        });

    }

}

export const doDelete = (type, url, postData) => {
    type = type.toUpperCase()
    return dispatch => {

        var id = postData

        dispatch({
            type: type + "_DELETE",
            isLoading: true,
        })

        var apiKey = cookies.get("auth")

        var headerData = {
            method: "DELETE",
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + apiKey
            }
        }

        var extUrl = ""
        var extUrlData = []
        if(postData!==null && postData!==undefined && typeof postData === 'object') {
            Object.keys(postData).forEach((key) => {
                extUrlData.push(key+"="+postData[key])
            });
            if(extUrlData.length > 0) {
                extUrl = "?" + extUrlData.join("&")
            }
        }

        fetch(API + url + extUrl, headerData)
            .then(data => {
                if(data.message !== undefined) {
                    throw new Error(data.message)
                }
                dispatch({
                    type: type+"_DELETE",
                    isLoading: false,
                    deleteId: id
                })
                dispatch({
                    type: REDUCER_NOTIFICATION,
                    messageType: "success",
                    message: "Eintrag wurde gelöscht"
                })
        }).catch(function(error) {
            dispatch({
                type: REDUCER_NOTIFICATION,
                messageType: "error",
                message: error.message
            })
        });

    }

}

export const doDuplicate = (type, url) => {
    type = type.toUpperCase()
    return dispatch => {

        dispatch({
            type: type + "_LOADING",
            isLoading: true,
        })

        var apiKey = cookies.get("auth")

        var headerData = {
            method: "GET",
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + apiKey
            }
        }

        fetch(API + url, headerData)
            .then(response => response.json())
            .then(data => {
                if(data.message !== undefined) {
                    throw new Error(data.message)
                }
                dispatch({
                    type: type+"_ADD",
                    newData: data,
                    isLoading: false,
                    dialogOpen: false
                })
                dispatch({
                    type: REDUCER_NOTIFICATION,
                    messageType: "success",
                    message: "Eintrag wurde erstellt!"
                })
            }).catch(function(error) {
                dispatch({
                    type: type+"_ERROR",
                    message: error.message
                })
            });

    }
}



// WEBPACK FOOTER //
// ./src/Redux/Actions.jsx